module.exports = __webpack_public_path__ + "fae3c934a7353e1defbb00343509b3aa.png";